import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Card, CardHeader, List, ListItem, ListItemText } from '@material-ui/core';
import CommentIcon from '@material-ui/icons/Comment';
import { Link } from 'react-router-dom';

const styles = {
  titleLink: { textDecoration: 'none', color: '#000' },
  card: { borderLeft: 'solid 4px #f44336', flex: 1, marginTop: '1em' },
  icon: { float: 'right', width: 64, height: 64, padding: 16, color: '#f44336' },
};

const location = { pathname: 'twitterusers' };

function redirect(id) {
  location.hash = location.pathname + '/' + id;
}

const TwitterStats = ({ items = { data: [] }, classes }) => (
  <Card className={classes.card}>
    <CommentIcon className={classes.icon} />
    <CardHeader
      title={
        <Link to={location} className={classes.titleLink}>
          Most Active Twitter Users
        </Link>
      }
      subtitle="30 days"
    />
    <List>
      {items.data &&
        items.data.map(record => (
          <ListItem
            onClick={redirect.bind(this, record.id)}
            key={record.id}
          >
            <ListItemText
              primary={record.user.name}
              secondary={`tweets: ${record.tweets} / retweets: ${record.retweets} / favorites: ${record.favorites} `}
            />
          </ListItem>
        ))}
    </List>
  </Card>
);

TwitterStats.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TwitterStats);


// WEBPACK FOOTER //
// ./src/dashboard/TwitterStats.js